import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-manager-list-page',
    templateUrl: './manager-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ManagerListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Managers');
  }

  handleRowSelect(data) {
    this.router.navigate(['/entity-data/manager', data['SystemManagerCode']]);
  }

  getRowHref = (row) => {
    const managerRef = row['SystemManagerCode'];
    return `/entity-data/manager/${managerRef}`;
  }
}
